module.exports = __webpack_public_path__ + "static/a7-56fa631359e38f4eee10c29ae41575ca.jpg";